import styled from 'styled-components'

export const Triangle = styled.div`
  position: relative;
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;

  border-top: 6px solid rgb(153, 153, 153);
  transition: 0.3s ease-in-out;
  transform: translateY(2px);
`
